Namespace 'Monitoring.Views.Charts'

class Monitoring.Views.Charts.ChartView extends Backbone.View
  errorTemplate: JST['backbone/templates/monitoring/charts/error_message']

  _dataIsEmpty: ->
    return false

  destroy: ->
    @$el.remove()
    @remove()
    @trigger('removeChart', @)

  settings: ->
    @_settings

  appendChart: (container) ->
    @eventAggregator.trigger('monitoring:chart:render', @getGAName())
    @render()
    container.append(@el)
    @afterAppend()
    @addNoteBox()

  addNoteBox: () ->
    @addLinkToNote()
    @noteChart = new Monitoring.Views.Charts.NoteChartView( @chart_note_name() )
    @$el.append(@noteChart.render(@settings().note).el)
    @displayNote() if @settings().note

  addLinkToNote: ->
    linkToNote = $('<a id="insert_note'+@chart_note_name()+'" class="insert-note no-print" style="cursor:pointer;position:absolute;top:15px;right:111px;z-index:500;"><i class="fa fa-pencil-square-o no-print" aria-hidden="true" style="font-size:17px;color:#000000;transform:scale(1.1)"></i></a>')
    @$el.find('#close_chart').before(linkToNote)

  afterAppend: ->

  retry: =>
    @render()
    @$el.addClass('processing')
    @afterAppend()

  ajaxCall: (url, data, success) =>
    @requests = @requests || []
    @requests.push($.ajax(
      type: "POST"
      url: url
      global: false
      data: data
      success: @ajaxResponse(success)
      error: @displayError
    ))

  createPreviewDashboard: (searchQuery)->
    @trigger('showSocialContentsPreview', searchQuery)

  ajaxResponse: (responseHandler) =>
    (response) =>
      if response.error?
        @displayError response
        return
      try
        responseHandler(response)
      catch error
        @handleResponseErrors error

  handleResponseErrors: (error) ->
    @abortPendingRequests()
    errorString = "Uncaught error in ajax response handler.\n" + error.stack
    jsLogger.fatal(errorString);
    @displayError()

  abortPendingRequests: ->
    request.abort for request in @requests

  _removeProcessing: =>
    @$el.removeClass('processing')
    @$el.find('.processing').removeClass('processing')

  _displayError: ({message, allowRetry}) =>
    @_removeProcessing()
    @$el.find('.chart').html('').addClass('chart-error').append(
      @errorTemplate(message: message, allowRetry: allowRetry)
    )
    @$el.removeClass('h2')
    @$el.find('.h2').removeClass('h2')
    @$el.find('.download-image').hide()
    @trigger('masonry')

  displayError: (response) =>
    if response?.status == 401
      @_displayError(message: I18n.t('monitoring.dashboard.charts.unauthorized'), allowRetry: false)
    else if response?.error_message
      @_displayError(message: response.error_message, allowRetry: false)
    else
      @_displayError(message: I18n.t('monitoring.dashboard.charts.generic_error'), allowRetry: true)

  translatedItems: (menuItems) ->
    _.each(menuItems, (item) ->
      if item.text == 'Download PNG image'
        item.text = I18n.t('monitoring.dashboard.charts.export_options.download_png')
      else if item.textKey == 'downloadCSV'
        item.text = I18n.t('monitoring.dashboard.charts.export_options.download_csv')
      else if item.textKey == 'downloadXLSX'
        item.text = I18n.t('monitoring.dashboard.charts.export_options.download_xlsx')
    )

  getGAName: () ->
    @title_en || @title || @constructor.name

  applyChartZoom: ->
    if @_settings.zoom
      @chart.xAxis[0].setExtremes(parseInt(@_settings.zoom['min']), parseInt(@_settings.zoom['max']))
      @chart.showResetZoom()

  legendItemClickEvent: (event) =>
    @_settings['visibleSeries'] ||= {}
    @_settings['visibleSeries'][event.target.name] = !event.target.visible # because visible has the value before has been clicked
    @searchQuery.changeState()
    return

  getVisibilityFor: (name) ->
    if @_settings.visibleSeries
      @_settings.visibleSeries[name] == true || @_settings.visibleSeries[name] == 'true' || @_settings.visibleSeries[name] == undefined
    else
      true

  onTimeseriesSelection: (event) ->
    if event.resetSelection
      @_settings.zoom = {}
    else
      @_settings.zoom = {min: event.xAxis[0].min, max: event.xAxis[0].max }
    @searchQuery.changeState()


  chart_note_name: =>
    _.str.underscored(@getGAName()).replace(/[^A-Z0-9]+/ig, "_") + '_';

  displayNote: =>
    if @.className.indexOf('chart-ranking') == -1
      @$el.addClass('margin-note-opened')
    @$el.find('#div_chart_note_' + @chart_note_name()).show()
    @trigger('masonry')

  hideNote: =>
    @$el.find('#div_chart_note_' + @chart_note_name()).hide()
    @$el.removeClass('margin-note-opened')
    @trigger('masonry')

  saveNote: =>
    @settings().note = @$el.find('#chart_note_' + @chart_note_name()).val()
    @trigger('chartsChange')
    showSuccess(I18n.t('monitoring.dashboard.charts.save_success'))

  deleteNote: =>
    @$el.find('#chart_note_' + @chart_note_name()).val("")
    @settings().note = ""
    @hideNote()
    @trigger('chartsChange')

  customColors: ->
    _.extend(@_defaultCustomColors(), @_customAttributesColors())

  _defaultCustomColors: ->
    negative: '#bf362e'
    neutral: '#999999'
    positive: '#84bd0e'
    missing: '#592e6f'
    facebook: '#125393'
    'fb-user': '#125393'
    twitter: '#55abde'
    'tw-user': '#55abde'
    'ig-user': '#863a8f'
    instagram: '#863a8f'
    instagramComment: '#863a8f'
    instagramMedia: '#863a8f'
    whatsapp: '#00d45e'
    email: '#61a126'
    apple_app_store: '#009ACF'
    google_play: '#FFCA00'
    google_search: '#34A853'
    gp_review_comment: '#FFCA00'
    google_my_business: '#acd2f2'
    'google-my-business': '#acd2f2'
    'google-my-business-reply': '#acd2f2'
    'google-my-business-review': '#acd2f2'
    clipping: '#F0F0F0'
    external_stream: '#9317C5'
    linkedin: '#488dc2'
    webchat: '#ff6900'
    youtube: '#ff0000'
    'yt-user': '#ff0000'
    tiktok: '#000000'

  _customAttributesColors: ->
    positivo: '#84bd0e'
    neutro: '#999999'
    negativo: '#bf362e'
